import React, {useContext} from "react";
import AppData, {initialAppDataState} from "./AppData";

export const AppDataContext = React.createContext<AppData>(initialAppDataState)
